import {
	ERROR_ACTION,
	ERROR_ACTION_SUBJECT,
	type ErrorType,
	EVENT_TAG_GROWTH,
	type Product,
	type Severity,
} from '../../common/constants/event-attributes';
import { type Team } from '../../common/constants/team';
import type { ExperimentMeta } from '../../common/types';

interface ErrorPayloadParams {
	additionalAttributes?: Record<string, any>;
	errorMessage: string;
	errorType: ErrorType;
	experimentMeta: ExperimentMeta;
	isActiveExperiment: boolean;
	product: Product;
	severity: Severity;
	source: string;
	team: Team;
}

/**
 * Creates a standardized error analytics payload
 *
 * @param params Parameters for the error payload
 * @returns A formatted error analytics payload
 */
export const createEventPayload = ({
	team,
	experimentMeta,
	errorType,
	errorMessage,
	source,
	severity,
	isActiveExperiment,
	product,
	additionalAttributes = {},
}: ErrorPayloadParams) => {
	const actionSubjectId = `${ERROR_ACTION_SUBJECT}-${experimentMeta.experimentKey}-${errorType}`;

	return {
		action: ERROR_ACTION,
		actionSubject: ERROR_ACTION_SUBJECT,
		actionSubjectId,
		source: experimentMeta.experimentKey,
		attributes: {
			errorType,
			team,
			experimentKey: experimentMeta.experimentKey,
			cohort: experimentMeta?.cohort,
			severity,
			errorMessage,
			isActiveExperiment,
			product,
			detailedSource: source,
			...additionalAttributes,
		},
		tags: [EVENT_TAG_GROWTH],
	};
};
